import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Text = styled.div<{
  marginTop?: string;
  color?: string;
  fontWeight?: string | number;
  fontSize?: string;
  textAlign?: string;

  mobileMarginTop?: string; // 모바일 전용 margin-top
  mobileFontSize?: string; // 모바일 전용 font-size
}>`
  display: flex;
  margin-top: ${({ marginTop = "0" }) => marginTop};
  color: ${({ color = "black" }) => color};
  font-weight: ${({ fontWeight = "bold" }) => fontWeight};
  font-size: ${({ fontSize = "32px" }) => fontSize};
  font-family: "Pretendard";
  text-align: ${({ textAlign = "center" }) => textAlign};
  white-space: pre-wrap;
  word-break: break-word;

  @media (max-width: 1550px) {
    font-size: ${({ mobileFontSize }) => mobileFontSize || "inherit"};
    margin-mobilemargintop: ${({ mobileMarginTop = "30px" }) =>
      mobileMarginTop};
  }
`;
const CustomContainer = styled.div<{
  padding?: string;
  marginTop?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
  borderRadius?: string;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  flexDirection?: string;
  gap?: string;
  border?: string;

  // 반응형 옵션
  mobilePadding?: string;
  mobileMargin?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  mobileBackgroundColor?: string;
  mobileBorderRadius?: string;
  mobileDirection?: string;
  mobileGap?: string;
  mobileMarginTop?: string;
}>`
  display: ${({ display = "flex" }) => display};
  padding: ${({ padding = "0px 0px 0px 0px" }) => padding};
  margin-top: ${({ marginTop = "0" }) => marginTop};
  width: ${({ width = "100%" }) => width};
  height: ${({ height = "auto" }) => height};
  background-color: ${({ backgroundColor = "transparent" }) => backgroundColor};
  border-radius: ${({ borderRadius = "0" }) => borderRadius};
  border: ${({ border = "none" }) => border};
  align-items: ${({ alignItems = "center" }) => alignItems};
  justify-content: ${({ justifyContent = "center" }) => justifyContent};
  flex-direction: ${({ flexDirection = "row" }) => flexDirection};
  gap: ${({ gap = "0" }) => gap};
  box-sizing: border-box;

  @media (max-width: 1550px) {
    padding: ${({ mobilePadding }) => mobilePadding || "inherit"};
    margin: ${({ mobileMargin }) => mobileMargin || "inherit"};
    width: ${({ mobileWidth }) => mobileWidth || "inherit"};
    height: ${({ mobileHeight }) => mobileHeight || "inherit"};
    background-color: ${({ mobileBackgroundColor }) =>
      mobileBackgroundColor || "inherit"};
    border-radius: ${({ mobileBorderRadius }) =>
      mobileBorderRadius || "inherit"};
    flex-direction: ${({ mobileDirection }) => mobileDirection || "inherit"};
    gap: ${({ mobileGap }) => mobileGap || "inherit"};
    margin-top: ${({ mobileMarginTop }) => mobileMarginTop || "inherit"};
  }
`;

const InquireContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 1192px;
  height: 300px;
  margin-top: 100px;
  margin-bottom: 120px;
  padding: 10px 5px 10px 5px;
  justify-content: center; //가로
  align-items: center; //세로
  border-radius: 19px;
  background-color: #00e186;

  @media (max-width: 1550px) {
    width: 333px;
    height: 387px;
    padding: 30px 5px 30px 5px;
  }
`;

const InquireWrapper = styled.div<{
  marginTop?: string;
  marginBottom?: string;
}>`
  height: auto;
  margin-top: ${({ marginTop }) => marginTop || "150px"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "50px"};
  display: flex; // 텍스트 조각들을 가로로 배치
  box-sizing: border-box;

  @media (max-width: 1550px) {
    margin-top: 0px;
  }
`;

const InquireButtonWarpper = styled.div`
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;

  @media (max-width: 1550px) {
    flex-direction: column;
  }
`;

const InquireButton = styled.button`
  background-color: white; // 버튼 배경 색
  color: black; // 버튼 텍스트 색
  font-size: 18px; // 텍스트 크기
  font-weight: 600;
  font-family: "Pretendard";
  padding: 12px 20px; // 여백
  border-radius: 100px; // 둥근 모서리
  border: 2px solid #00be71;
  box-sizing: border-box;
  cursor: pointer; // 마우스 커서가 버튼 위에 있을 때 손 모양
  margin: 30px; // 버튼 간의 간격
  width: 220px;
  height: 60px;
  /* 기본 그림자 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  &:hover,
  &:active {
    border: 2px solid white;
    color: #00be71;
    border-color: #00be71; // 마우스를 올리거나 클릭했을 때 테두리 굵기 변경
  }

  &:focus {
    outline: none; // 버튼 클릭 시 테두리 없애기
  }

  @media (max-width: 1550px) {
    width: 200px;
    height: 50px;
    gap: 10px;
    font-size: 20px;
    margin: 10px;
  }
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const InquireComponent = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1550);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1550); // 375px 이하이면 모바일로 판단
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <InquireContainer>
      <InquireWrapper marginTop="60px" marginBottom="10px">
        {isMobile ? (
          <Text
            fontSize="32px"
            color="black"
            fontWeight="Regular"
            mobileFontSize="26px"
            mobileWidth="100%"
          >
            <CustomContainer mobileDirection="column" width="100%">
              <CustomContainer mobileDirection="row" width="100%">
                <BoldText>슬라임과</BoldText> 함께 <BoldText>성공가도</BoldText>
                를
              </CustomContainer>
              <Text
                fontWeight="Regular"
                fontSize="26px"
                mobileFontColor="black"
              >
                달려보시겠어요?
              </Text>
            </CustomContainer>
          </Text>
        ) : (
          <Text
            fontSize="32px"
            color="black"
            fontWeight="Regular"
            mobileFontSize="26px"
          >
            <BoldText>슬라임과</BoldText> 함께 <BoldText>성공가도</BoldText>를
            달려보시겠어요?
          </Text>
        )}
      </InquireWrapper>
      <InquireButtonWarpper>
        <InquireButton>문의 하기</InquireButton>
        <InquireButton>제안 하기</InquireButton>
        <InquireButton>채용 바로가기</InquireButton>
      </InquireButtonWarpper>
    </InquireContainer>
  );
};

export default InquireComponent;
